<template>
  <el-form
    :model="params"
    :rules="rules"
    hide-required-asterisk
    class="login__form"
    label-width="27px"
    ref="form"
  >
    <el-form-item
      v-input-border="{ className: 'is-focus' }"
      prop="username"
      class="login__user_name border--bottom"
    >
      <i
        slot="label"
        class="b-icon-user b-icon__collor"
      />
      <el-input
        v-model="params.username"
        placeholder="用户名"
        class="border--hidden"
        @keypress.native.enter="submit()"
      />
    </el-form-item>
    <el-form-item
      v-input-border="{ className: 'is-focus' }"
      prop="email"
      class="login__password border--bottom"
    >
      <i
        slot="label"
        class="b-icon-email b-icon__collor"
      />
      <el-input
        v-model="params.email"
        type="email"
        placeholder="邮箱"
        class="border--hidden login__input-password"
        @keypress.native.enter="submit()"
      />
    </el-form-item>
    <div class="login__form-checkbox clearfix">
      <span
        @click="redirectToModule"
        class="link text-primary pull-right"
      >返回上级</span>
    </div>
    <el-form-item
      label-width="0"
      class="login__form-footer"
    >
      <el-button
        type="primary"
        size="large"
        class="login__submit"
        round
        :loading="loading"
        @click="submit()"
      >下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { UPDATE_TOKEN } from 'store/mutation-types'
import * as api from 'index/api'
export default {
  name: 'ForgotPassword',
  data () {
    return {
      loading: false,
      params: {
        username: '',
        email: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入用户名'
          }
        ],
        email: [
          {
            required: true,
            message: '请输入正确的邮箱地址'
          },
          {
            validator: (rule, value, callback) => {
              return this.submit(callback)
            },
            trigger: ['submit']
          }
        ]
      }
    }
  },

  methods: {
    redirectToModule () {
      this.$emit('redirectToModule', 'login')
    },
    submit (callback) {
      if (callback) {
        this.$refs.form.validateField('username', err => {
          if (err) return callback(new Error(err))
          this.submitForgotPwd(this.params, callback)
        })
      } else {
        this.$refs.form.validateField('username', (value, rule) => {
          if (!value) {
            this.$refs.form.validateField('email')
          }
        })
      }
    },
    submitForgotPwd (params, callback) {
      this.loading = true
      this.$store.dispatch(UPDATE_TOKEN).then(token => {
        // const { email, username } = params
        api.sendEmail(this.params).then(() => {
          this.loading = false
          this.$store.commit(UPDATE_TOKEN, token)
          // this.$emit('redirectToModule', 'login')
          this.$message({
            type: 'info',
            message: '发送成功，请前往您的邮箱重置密码'
          })
        }).catch(err => {
          this.loading = false
          const { data } = err || {}
          const { message: msg = err.message } = data || {}
          let message = msg || '找回失败'
          callback && callback(new Error(message))
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.b-icon__collor {
    color: #8e96a5;
  }
</style>
